import ExcelJS from 'exceljs';
export interface FileResult {
  // metadata
  metadata: Metadata;

  // activity
  rows: Record<string, RowResult>;
}

export interface RowResult {
  isotope: string;
  activity: string;
  uncertaintyPct: string;
  uncertaintyValue: string;
  decisionThreshold: string;
  detectionLimit: string;
}

export interface UnitsReference {
  fileName: string;
  metadata: Record<string, string>;
  measurements: UnitsMeasurement;
}

export interface UnitsMeasurement {
  activityUnit: string;
  uncertaintyValueUnit: string;
  decisionThresholdUnit: string;
  detectionLimitUnit: string;
}

export interface Metadata {
  mass: string;
  dateOfAcquisition: string;
  realTime: string;
  observations: string[];
}

export interface ExcelHeader {
  colAttributes: ExcelJS.Column;
  isRn: boolean;
}

export enum UnitsReferenceEnum {
  MASS = 'MASS',
  REALTIME = 'REALTIME',
  MEASUREMENTS = 'MEASUREMENTS'
}
